'use strict';

var novicell = novicell || {};
var dgv = dgv || {};

dgv.accordions = dgv.accordions || function () {

	function init(container) {
		var accordions = container.querySelectorAll('.js-accordion');

		if ( accordions ) {
			accordionFunction(accordions);
		}
	}

	function accordionFunction(accordions) {
		for (var i = 0; i < accordions.length; i++) {
			let accordion 	= accordions[i],
				trigger 	= accordion.querySelector('.js-accordion__toggle'),
				btn_text 	= trigger.querySelector('.job-item__read-more-text').innerHTML;

			trigger.addEventListener('click', function(e) {
				e.stopPropagation();

				let current 		= trigger.parentNode,
					content 		= current.querySelector('.js-accordion__content'),
					active			= current.parentNode.querySelector('.js-accordion.active'),
					btn 			= trigger.querySelector('.job-item__read-more-text');

				if ( current.classList.contains('ready') ) {
					if ( active ) {
						var active_content 	= active.querySelector('.js-accordion__content'),
							active_btn 		= active.querySelector('.job-item__read-more-text');

						setTimeout(function() {
							active_content.style.height = '0';
							active.classList.remove('active');

							active_btn.innerHTML = btn_text;
						}, 10);

						setTimeout(function() {
							active.classList.add('ready');
						}, 600);
					}

					current.classList.add('active');
					current.classList.remove('ready');

					// Create variable with the height and then hide it again
					content.style.height = 'auto';
					var content_height = content.clientHeight;
					content.style.height = '0';

					// Set the height from the newly created variable
					setTimeout(function() {
						content.style.height = content_height + 'px';

						btn.innerHTML = 'Luk igen ';
					}, 10);
				} else {
					content.style.height = '0px';
					current.classList.remove('active');
					btn.innerHTML = btn_text;

					setTimeout(function() {
						current.classList.add('ready');
					}, 600);
				}
			});
		};
	}

	return {
		init : init
	};

}();